/* SuperMall v2 — theme.js */
(function () {
  'use strict';

  // ─── HEADER SCROLL ─────────────────────────────────────────
  var header = document.getElementById('site-header');
  function onHeaderScroll() {
    if (header) header.classList.toggle('scrolled', window.scrollY > 50);
  }
  if (header) {
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  // ─── HEADER HEIGHT CSS VAR ──────────────────────────────────
  function setHeaderHeight() {
    var h = header ? header.offsetHeight : 0;
    document.documentElement.style.setProperty('--header-h', h + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight, { passive: true });

  // ─── OVERLAY ───────────────────────────────────────────────
  var overlay = document.getElementById('overlay');
  function showOverlay() { if (overlay) overlay.classList.add('visible'); }
  function hideOverlay() { if (overlay) overlay.classList.remove('visible'); }
  if (overlay) overlay.addEventListener('click', closeAll);

  function closeAll() {
    closeMobileDrawer();
    closeSearchPanel();
    closeFilterSidebar();
  }

  // ─── MOBILE DRAWER ─────────────────────────────────────────
  var drawer = document.getElementById('mobile-drawer');
  var drawerOpenBtn = document.getElementById('drawer-open');
  var drawerCloseBtn = document.getElementById('drawer-close');

  function openMobileDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    showOverlay();
    document.body.style.overflow = 'hidden';
    if (drawerOpenBtn) drawerOpenBtn.setAttribute('aria-expanded', 'true');
  }

  function closeMobileDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (drawerOpenBtn) drawerOpenBtn.setAttribute('aria-expanded', 'false');
    if (!isSearchOpen() && !isFilterOpen()) hideOverlay();
  }

  if (drawerOpenBtn) drawerOpenBtn.addEventListener('click', openMobileDrawer);
  if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeMobileDrawer);

  // ─── DRAWER ACCORDION ──────────────────────────────────────
  document.querySelectorAll('.drawer-expand').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.drawer-has-sub');
      if (!item) return;
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.drawer-has-sub.open').forEach(function (el) {
        el.classList.remove('open');
        var b = el.querySelector('.drawer-expand');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ─── FILTER GROUP TOGGLE ────────────────────────────────────
  document.querySelectorAll('.filter-group-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.filter-group');
      var body = group ? group.querySelector('.filter-group-body') : null;
      if (!body) return;
      var open = btn.getAttribute('aria-expanded') !== 'false';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      body.style.display = open ? 'none' : '';
    });
  });

  // ─── SEARCH PANEL ──────────────────────────────────────────
  var searchPanel = document.getElementById('search-panel');
  var searchBtn = document.getElementById('search-btn');
  var searchCloseBtn = document.getElementById('search-close');
  var searchInput = searchPanel ? searchPanel.querySelector('input[name="q"]') : null;

  function isSearchOpen() {
    return searchPanel && searchPanel.classList.contains('open');
  }

  function openSearchPanel() {
    if (!searchPanel) return;
    searchPanel.classList.add('open');
    searchPanel.setAttribute('aria-hidden', 'false');
    showOverlay();
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 80);
  }

  function closeSearchPanel() {
    if (!searchPanel) return;
    searchPanel.classList.remove('open');
    searchPanel.setAttribute('aria-hidden', 'true');
    if (!isDrawerOpen() && !isFilterOpen()) hideOverlay();
  }

  function isDrawerOpen() {
    return drawer && drawer.classList.contains('open');
  }

  if (searchBtn) searchBtn.addEventListener('click', openSearchPanel);
  if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearchPanel);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  // ─── FILTER SIDEBAR ────────────────────────────────────────
  var filterSidebar = document.getElementById('filter-sidebar');
  var filterToggle = document.getElementById('filter-toggle');
  var filterSidebarClose = document.getElementById('filter-sidebar-close');

  function isFilterOpen() {
    return filterSidebar && filterSidebar.classList.contains('open');
  }

  function openFilterSidebar() {
    if (!filterSidebar) return;
    filterSidebar.classList.add('open');
    showOverlay();
    document.body.style.overflow = 'hidden';
  }

  function closeFilterSidebar() {
    if (!filterSidebar) return;
    filterSidebar.classList.remove('open');
    document.body.style.overflow = '';
    if (!isDrawerOpen() && !isSearchOpen()) hideOverlay();
  }

  if (filterToggle) filterToggle.addEventListener('click', openFilterSidebar);
  if (filterSidebarClose) filterSidebarClose.addEventListener('click', closeFilterSidebar);

  // ─── SORT SELECT ───────────────────────────────────────────
  var sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // ─── SCROLL REVEAL ─────────────────────────────────────────
  var revealEls = document.querySelectorAll('.scroll-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    revealEls.forEach(function (el) { revealObs.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('revealed'); });
  }

  // ─── PRODUCT GALLERY ───────────────────────────────────────
  var mainImg = document.getElementById('main-product-img');
  if (mainImg) {
    document.querySelectorAll('.gallery-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.src;
        var alt = thumb.dataset.alt || '';
        if (src) { mainImg.src = src; mainImg.alt = alt; }
        document.querySelectorAll('.gallery-thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  // ─── PRODUCT TABS ──────────────────────────────────────────
  document.querySelectorAll('.product-tabs').forEach(function (tabGroup) {
    tabGroup.querySelectorAll('.tab-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.dataset.tab;
        tabGroup.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-selected', 'false'); });
        tabGroup.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
        btn.classList.add('active');
        btn.setAttribute('aria-selected', 'true');
        var panel = tabGroup.querySelector('[data-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });
  });

  // ─── QUANTITY SELECTOR ─────────────────────────────────────
  document.querySelectorAll('.qty-selector').forEach(function (sel) {
    var input = sel.querySelector('.qty-input');
    if (!input) return;
    var minusBtn = sel.querySelector('.qty-minus');
    var plusBtn = sel.querySelector('.qty-plus');
    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v - 1);
        input.dispatchEvent(new Event('change'));
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        var max = parseInt(input.max, 10) || 99;
        input.value = Math.min(max, v + 1);
        input.dispatchEvent(new Event('change'));
      });
    }
  });

  // ─── VARIANT SWATCHES ──────────────────────────────────────
  var variantSelect = document.getElementById('variant-select');
  var variantIdInput = document.getElementById('variant-id-input');
  var atcBtn = document.getElementById('atc-btn');
  var priceEl = document.getElementById('product-price');
  var comparePriceEl = document.getElementById('product-compare-price');
  var stockEl = document.querySelector('.product-stock');
  var variantsData = [];

  var variantsJson = document.getElementById('variants-json');
  if (variantsJson) {
    try { variantsData = JSON.parse(variantsJson.textContent); } catch (e) {}
  }

  function formatMoney(cents) {
    if (!cents) return '';
    var symbol = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EGP';
    return symbol + ' ' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updateVariantUI(variantId) {
    var variant = variantsData.find(function (v) { return v.id === variantId; });
    if (!variant) return;
    if (variantIdInput) variantIdInput.value = variantId;
    if (atcBtn) atcBtn.dataset.variantId = variantId;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
    if (stockEl) {
      stockEl.className = 'product-stock';
      if (variant.available) {
        if (variant.inventory_management === 'shopify' && variant.inventory_quantity <= 5 && variant.inventory_quantity > 0) {
          stockEl.classList.add('product-stock--low');
          stockEl.textContent = '⚡ Only ' + variant.inventory_quantity + ' left in stock';
        } else {
          stockEl.classList.add('product-stock--in');
          stockEl.textContent = '✓ In Stock';
        }
      } else {
        stockEl.classList.add('product-stock--out');
        stockEl.textContent = '✗ Out of Stock';
      }
    }
    if (variant.featured_image && mainImg) {
      mainImg.src = variant.featured_image.src;
    }
  }

  document.querySelectorAll('.variant-swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      var optionName = swatch.dataset.optionName;
      var optionValue = swatch.dataset.optionValue;
      var swatchGroup = document.getElementById('variant-option-' + optionName.toLowerCase().replace(/\s+/g, '-'));
      if (swatchGroup) {
        swatchGroup.querySelectorAll('.variant-swatch').forEach(function (s) { s.classList.remove('active'); });
      }
      swatch.classList.add('active');
      var labelEl = document.getElementById('selected-' + optionName.toLowerCase().replace(/\s+/g, '-'));
      if (labelEl) labelEl.textContent = optionValue;
      var matchedVariant = variantsData.find(function (v) {
        if (!v.options) return false;
        return v.options.every(function (opt, idx) {
          var sel = document.querySelectorAll('.variant-swatch.active')[idx];
          return !sel || sel.dataset.optionValue === opt;
        });
      });
      if (matchedVariant) {
        if (variantSelect) variantSelect.value = matchedVariant.id;
        updateVariantUI(matchedVariant.id);
      }
    });
  });

  if (variantSelect && variantSelect.tagName === 'SELECT') {
    variantSelect.addEventListener('change', function () {
      updateVariantUI(parseInt(variantSelect.value, 10));
    });
  }

  // ─── AJAX ADD TO CART ──────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.atc-btn');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;
    var qtyInput = btn.closest('form') ? btn.closest('form').querySelector('[name="quantity"]') : null;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (isNaN(qty) || qty < 1) qty = 1;
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Failed to add'); });
        return res.json();
      })
      .then(function () {
        btn.textContent = '✓ Added!';
        btn.classList.add('added');
        return updateCartCount();
      })
      .then(function () {
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = originalText;
          btn.classList.remove('added');
        }, 2000);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = originalText;
        console.error('Add to cart error:', err.message);
      });
  });

  function updateCartCount() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var count = data.item_count || 0;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = count;
          el.style.display = count > 0 ? '' : 'none';
        });
        document.querySelectorAll('[data-cart-badge]').forEach(function (el) {
          el.textContent = count;
          el.style.display = count > 0 ? '' : 'none';
        });
        if (document.body) document.body.dataset.cartCount = count;
      });
  }

  // ─── CART: QUANTITY CHANGE ─────────────────────────────────
  document.querySelectorAll('.cart-qty-input').forEach(function (input) {
    var timer;
    input.addEventListener('change', function () {
      clearTimeout(timer);
      var key = input.dataset.lineKey;
      var qty = parseInt(input.value, 10);
      if (!key || isNaN(qty)) return;
      timer = setTimeout(function () {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.reload(); })
          .catch(function (e) { console.error(e); });
      }, 600);
    });
  });

  // ─── CART: REMOVE ITEM ─────────────────────────────────────
  document.querySelectorAll('.cart-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.dataset.lineKey;
      if (!key) return;
      btn.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function (e) { btn.disabled = false; console.error(e); });
    });
  });

  // ─── SEARCH AUTOCOMPLETE ───────────────────────────────────
  if (searchInput) {
    var searchDebounce;
    searchInput.addEventListener('input', function () {
      clearTimeout(searchDebounce);
      var q = searchInput.value.trim();
      if (q.length < 2) return;
      searchDebounce = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var results = data.resources && data.resources.results ? data.resources.results.products : [];
            renderSearchSuggestions(results, q);
          })
          .catch(function () {});
      }, 300);
    });
  }

  function renderSearchSuggestions(products, q) {
    var panel = document.getElementById('search-panel');
    var existing = panel ? panel.querySelector('.search-suggestions-list') : null;
    if (existing) existing.remove();
    if (!products || !products.length || !panel) return;
    var list = document.createElement('ul');
    list.className = 'search-suggestions-list';
    products.forEach(function (p) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = p.url;
      a.className = 'search-suggestion-item';
      if (p.image) {
        var img = document.createElement('img');
        img.src = p.image; img.alt = p.title; img.width = 48; img.height = 48;
        a.appendChild(img);
      }
      var info = document.createElement('span');
      info.className = 'suggestion-info';
      info.innerHTML = '<span class="suggestion-title">' + p.title + '</span><span class="suggestion-price">' + p.price + '</span>';
      a.appendChild(info);
      li.appendChild(a);
      list.appendChild(li);
    });
    var form = panel.querySelector('.search-form, .search-panel-form');
    if (form) form.after(list);
  }

  document.addEventListener('click', function (e) {
    if (searchPanel && !searchPanel.contains(e.target) && e.target !== searchBtn) {
      var sugg = searchPanel.querySelector('.search-suggestions-list');
      if (sugg) sugg.remove();
    }
  });

})();